module.exports = __webpack_public_path__ + "static/parade-2019-house06-18f78bf1d7c3b5b05d6b9e810feff43a.jpg";